module.exports = __webpack_public_path__ + "static/media/certificate-gradient.bf389bf7.png";